import { Section } from "../../jobs-flow/Section";

export default class LeadsManagement{
    constructor(){
        this.searchParams = new Proxy(new URLSearchParams(window.location.search), {
            set: (searchParams, prop, newValue) => {
                searchParams.set(prop, newValue);
                window.location.search = searchParams.toString();
                return true;
            },
        });
        this.initPagination();
    }

    initPagination(){
        let section = new Section('leads', true);
        section.show();
    }
}
